module.exports = {
  deleted_tokens: "You've been logged out on a different device. | You've been logged out on {x} other devices.",
  quiz: 'Quiz-Battle',
  title: 'Notifications',
  error: 'Errors',
  info: 'Info',
  update_available: 'Update available',
  reload_to_update: 'A new version of the app is available. Refresh the page to activate the latest version.',
  reload_app: 'Reload app',
  max_file_size: 'You can\'t upload a file larger than {size}MB!',
  max_file_count: 'You can\'t upload more than {count} file.',
  failed_to_send_message: 'The message could not be sent.',
  chat_sent_image: 'sent an image',
  chat_sent_video: 'sent a video',
  chat_sent_file: 'sent a file',
}
